import React from "react";
import Chart from "../../components/chart/Chart";
import FeaturedInfo from "../../components/featuredInfo/FeaturedInfo";
import WidgetLg from "../../components/widgetes/widgetLg/WidgetLg";
import WidgetSm from "../../components/widgetes/widgetSm/WidgetSm";
import { userData } from "../../data/fakeChart";
import './home.css'
const Home = () => {
  return (
    <div className="home" >
      <FeaturedInfo />
      <Chart
        data={userData}
        title="User Analytics"
        grid
        dataKey="Active User"
      />
      <div className="home_widgets">
        <WidgetSm />
        <WidgetLg />
      </div>
    </div>
  );
};

export default Home;
